import React from "react";
import IRepertoireComponentDataItem from "../../../redux/types/IRepertoireComponentDataItem";
import { Form, Formik } from "formik";
import { ALBUM_RATE_TYPE, CARRIER_TYPE, PRODUCT_DETAILS } from "../../Consts";
import { ILookupDictionary } from "../../../lookup/types/ILookupDictionary";
import { getLookupValues } from "../../../lookup/services/LookupHelpers";
import { SizedDropdownDataInputFormik, makeOptionsList } from "../../components/dropdownDataInput/DropdownDataInputFormik";
import { ALBUM_RATE_TYPE_LOOKUP, RECORDING_FORMAT_LOOKUP } from "../../../lookup/Consts";
import * as Yup from 'yup';
import { updateProductField, updateProductFields } from "../../../redux/reducers/RepertoireReducer";
import { IProductState } from "../../../redux/types/IProductState";

const productDetailsTabSchema = (fieldData) => {
    const schema = Yup.object().shape(
        {
            albumRateType: fieldData?.albumRateType?.isMandatory ? Yup.object().shape({
                data: Yup.string().nullable(),
            }
            ).test(
                'empty-check',
                'Album rate type can not be empty',
                val => !(!val.data || val.data === "" || val.data.length <= 0)) : Yup.object().shape({
                    data: Yup.string().nullable(),
                }).nullable().notRequired(),
            carrierType: fieldData?.carrierType?.isMandatory ? Yup.object().shape({
                data: Yup.string().nullable(),
            }
            ).test(
                'empty-check',
                'Carrier type can not be empty',
                val => !(!val.data || val.data === "" || val.data.length <= 0)) : Yup.object().shape({
                    data: Yup.string().nullable(),
                }).nullable().notRequired(),
        }
    )
    return schema;
}

export const formatProductProductDetailsForState = (values, productDetails) => {
    const formatProductProductDetailsForState = {
        ...productDetails,
        albumRateType: values?.albumRateType?.data ? values.albumRateType.data : null,
        carrierType: values?.carrierType?.data ? values.carrierType.data : null,
    }
    return formatProductProductDetailsForState;
}
export interface IProductMaintenanceProductSectionProps {
    dataGridTableData?: IRepertoireComponentDataItem;
    lookupValues?: ILookupDictionary;
    isFormVisible: boolean;
    productProductFormikRef: any;
    updateProductFields: typeof updateProductFields;
    product?: IProductState;
    setIsChangeProductDetailsForm: (value: boolean) => void;
    changeData: typeof updateProductField;
}

const DropDownField = (viewData, name, lookupValues, componentInstance, isReadOnly, errors, onChange, placeholder) => {
    let lookUpValuesLocal = getLookupValues(componentInstance, lookupValues);
    return <SizedDropdownDataInputFormik
        label={viewData.data}
        fieldName={name}
        useComboBoxAsMenuWidth={true}
        options={lookUpValuesLocal}
        allowNull={true}
        readOnly={isReadOnly}
        isHidden={!viewData.data}
        errors={errors}
        onChange={onChange}
        placeholder={placeholder}
    />
}

const ProductMaintenanceProductSection: React.FC<IProductMaintenanceProductSectionProps> = ({
    product,
    dataGridTableData,
    lookupValues,
    isFormVisible,
    productProductFormikRef,
    updateProductFields,
    setIsChangeProductDetailsForm,
    changeData,
}) => {

    const [fields, setFields] = React.useState([]);
    const [viewData, setViewData]: any = React.useState({});

    React.useEffect(() => {
        const filteredFields = dataGridTableData?.fields?.filter(field => field.componentInstance === PRODUCT_DETAILS);
        setFields(filteredFields);
    }, [dataGridTableData]);

    React.useEffect(() => {
        if (dataGridTableData.fields) {
            const visibleFields = dataGridTableData.fields.filter(field => field.componentInstance === PRODUCT_DETAILS);
            const data = {};
            visibleFields.forEach(item => {
                data[item.name] = item;

                if (Object.keys(data).length === visibleFields.length) {
                    setViewData(data);
                }
            });
        }
    }, [dataGridTableData])

    React.useEffect(() => {
        return () => {
            productProductFormikRef?.current?.values && handleSubmit(productProductFormikRef.current.values)
        }
    }, [])

    const isFieldPresent = (fieldName, viewData) => {
        return viewData && viewData.name && viewData.name === fieldName;
    }

    const handleSubmit = (values) => {
        updateProductFields({
            isProductProductDetails: true,
            productDetails: formatProductProductDetailsForState(values, product.productDetails)
        });
    }
    const handleDataChange = () => {
        setIsChangeProductDetailsForm(true);
    }

    const getInitialValueDropDown = (initialValue, lookupName) => {
        const lookUpValuesLocal = getLookupValues(lookupName, lookupValues);
        const sourceOptions = makeOptionsList(true, lookupName, lookUpValuesLocal, false)
        const foundOption = sourceOptions.find(option => option.data === initialValue || option.text === initialValue);
        return foundOption ? foundOption : { data: initialValue };
    }

    return <div className="AccordionContainer">
        <Formik
            enableReinitialize
            validateOnChange
            initialValues={{
                albumRateType: product?.productDetails?.albumRateType ? getInitialValueDropDown(product.productDetails.albumRateType, ALBUM_RATE_TYPE_LOOKUP) : { data: '' },
                carrierType: product?.productDetails?.carrierType ? getInitialValueDropDown(product.productDetails.carrierType, RECORDING_FORMAT_LOOKUP) : { data: '' }
            }}
            validate={(values) => {
                const schema = productDetailsTabSchema(viewData);
                try {
                    schema.validateSync(values, { abortEarly: false });
                    return {};
                } catch (errors: any) {
                    const formikErrors = {};
                    errors && errors.inner && errors.inner.forEach((error) => {
                        formikErrors[error.path] = error.message;
                    });
                    return formikErrors;
                }
            }}
            onSubmit={(values, { setSubmitting }) => {
                handleSubmit(values);
                setSubmitting(false);
            }}
        >
            {({ values, submitForm, errors, validateForm }) => {
                productProductFormikRef.current = {
                    values: values,
                    submitForm: submitForm,
                    validateForm: validateForm,
                    errors: errors,
                }
                return (
                    <Form>
                        {isFormVisible && <div className="formItemsContainer flexColumn">
                            <div className="row">
                                {fields && fields.map(field => {
                                    return isFieldPresent(ALBUM_RATE_TYPE, field) && DropDownField(field, ALBUM_RATE_TYPE, lookupValues, ALBUM_RATE_TYPE_LOOKUP, false, errors, handleDataChange, values.albumRateType.data);
                                })}
                                {fields && fields.map(field => {
                                    return isFieldPresent(CARRIER_TYPE, field) && DropDownField(field, CARRIER_TYPE, lookupValues, RECORDING_FORMAT_LOOKUP, false, errors, handleDataChange, values.carrierType.data);
                                })}
                            </div>
                        </div>}
                    </Form>
                )
            }}
        </Formik>
    </div>

}

export default ProductMaintenanceProductSection;